<span class="cmdk-ask-row__glyph" aria-hidden="true">
  <im-ask-mark [size]="18" [animate]="false" />
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ title() }}</span>
  <span class="cmdk-row__subtitle">{{ subtitle() }}</span>
</span>

<paper-kbd class="cmdk-row__shortcut" keys="↵" [mod]="true" label="Enter" size="sm" />
